import { useBlocker } from "react-router-dom";
import { useCallback, useEffect } from "react";

import { showBlockNavigationModal } from "./BlockNavigationModal";

type UseBlockNavigationModalProps = {
  isNavigationBlocked: boolean;
  title?: string;
  description?: string;
  onConfirm?: () => void;
};

const useBlockNavigationModal = ({
  isNavigationBlocked,
  title,
  description,
  onConfirm,
}: UseBlockNavigationModalProps) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isNavigationBlocked && currentLocation.pathname !== nextLocation.pathname
  );

  const onNavigationConfirm = useCallback(() => {
    onConfirm?.();
    blocker?.proceed?.();
  }, [blocker, onConfirm]);

  useEffect(() => {
    if (blocker.state === "blocked")
      showBlockNavigationModal({ title, description, onConfirm: onNavigationConfirm });
  }, [blocker.state, title, description, onNavigationConfirm]);
};

export default useBlockNavigationModal;
